import React from 'react';
import { Box, TextField, ToggleButton, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import type { ScriptStep } from '@shared/interfaces/assistantScripts';
import {
  ScriptToggleButtonGroup,
  SectionLabelText,
} from '../AssistantScriptDialog.styled';
import { FieldLabel } from './styled';

interface AdvanceToNextStepOptionsProps {
  step: ScriptStep;
  onUpdateStep: (data: Partial<ScriptStep>) => void;
}

const AdvanceToNextStepOptions = ({
  step,
  onUpdateStep,
}: AdvanceToNextStepOptionsProps) => {
  const { t } = useTranslation('common');

  return (
    <Box>
      <SectionLabelText>{t('assistant.scriptDialog.advanceToNextStep')}</SectionLabelText>
      <ScriptToggleButtonGroup
        value={step.advanceOnAudioEnd ? 'audio_end' : 'delay'}
        exclusive
        onChange={(_, value) => {
          if (value !== null) {
            onUpdateStep({ advanceOnAudioEnd: value === 'audio_end' });
          }
        }}
        size="small"
        sx={{ mb: 1.5 }}
      >
        <ToggleButton value="audio_end">{t('assistant.scriptDialog.whenAudioEnds')}</ToggleButton>
        <ToggleButton value="delay">{t('assistant.scriptDialog.afterDelay')}</ToggleButton>
      </ScriptToggleButtonGroup>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: 'block' }}
      >
        {step.advanceOnAudioEnd
          ? t('assistant.scriptDialog.advanceOnAudioEndDesc')
          : t('assistant.scriptDialog.advanceOnDelayDesc')}
      </Typography>
      {!step.advanceOnAudioEnd && (
        <Box sx={{ mt: 1.5 }}>
          <FieldLabel>{t('assistant.scriptDialog.delayInSeconds')}</FieldLabel>
          <TextField
            size="small"
            type="number"
            value={step.delayBeforeAdvancing}
            InputProps={{ inputProps: { min: 0, max: 100 } }}
            onChange={(e) =>
              onUpdateStep({ delayBeforeAdvancing: +e.target.value })
            }
            sx={{ mt: 0.5, width: '100px' }}
          />
        </Box>
      )}
    </Box>
  );
};

export default AdvanceToNextStepOptions;
